import { useEffect, useState } from "react";
import TableAHSF from "../../../../Components/TableAHSF";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/VariousVariables";
import PopupAHSF from "../../../../Components/PopupAHSF";
import AddEditInformationTargetGroup from "./AddEditInformationTargetGroup";
import { GetTargetInfo } from "../../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject";
import { decryptToken } from "../../../../Services/Account/EncryptionParams";
import { useParams } from "react-router-dom";

const InformationTargetGroupProjectTable = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();

  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [TargetGroupId, setTargetGroupId] = useState(null);

  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const state = useSelector((state) => {
    return {
      TargetInfo: state.TargetInfo.TargetInfo,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  //console.log(state.TargetInfo?.tG_MainTargetedGroupId, "TargetInfo");

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  const RequestAccessor = [
    {
      KeyName: "myPNatureOfTargetedGrouproperty",
      ShowStatus: true,
      NmaeColumn: "طبيعة الفئة المستهدفة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "targetedGroupAgeText",
      ShowStatus: true,
      NmaeColumn: "عمر  الفئة المستهدفة",
      TotalNumber: true,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    ,
    {
      KeyName: "expectedNumberOfBeneficiaries",
      ShowStatus: true,
      NmaeColumn: "العدد المتوقع من المستفيدين",
      TotalNumber: true,
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      comma : true,
    },
    ,
    {
      KeyName: "additionalInformation",
      ShowStatus: true,
      NmaeColumn: "معلومات أخرى",
      TotalNumber: false,
      DropdownFiltrationStatus: true,
      DropdownFiltration: {
        keyTextName: "statusNameAr",
        keyValueName: "aP_StageId",
      },
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        setTargetGroupId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: !shouldDisableFields?"bi bi-pencil-square":"bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/TargetedGroup/DeleteTG_TargetedGroup",
              {
                tG_TargetedGroupId: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !shouldDisableFields,
    },
  ];

  const RequestsColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <AddEditInformationTargetGroup />
      </div>
    ),
    title: "معلومات عن الفئة المستهدفة ضمن المشروع",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const getJson = async () => {
    var json = await loadConfig();
    return json;
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);
  useEffect(() => {
    dispatch(
      GetTargetInfo(state.ApplicationInformation.aI_ApplicationInformationId||
        decryptToken(AppGuid.AppGuid))
    );
  }, []);

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditInformationTargetGroup
          tG_TargetedGroupId={TargetGroupId}
          canEdit="edit"
        />
      </div>
    ),
    title: "معلومات عن الفئة المستهدفة ضمن المشروع",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  //console.log(props.tG_MainTargetedGroupId, "tG_MainTargetedGccccccccroupId");

  return props.tG_MainTargetedGroupId ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"tG_TargetedGroupId"}
        valueButtonAction={"tG_TargetedGroupId"}
        URL={`api/TargetedGroup/GetListTG_TargetedGroup`}
        UrlBody={{
          tG_MainTargetedGroupId: props.tG_MainTargetedGroupId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"معلومات عن الفئة المستهدفة ضمن المشروع"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!shouldDisableFields}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  ) : (
    ""
  );
};

export default InformationTargetGroupProjectTable;
